import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const rovoRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'rovo',
	path: '/rovo',
	layout: 'home',
	nav4Layout: 'expanded',
});
